
/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$( document ).ready(function() {

  //collection add to cart
  $("body").on(  "click", '#it_col_v2 .product__add-to-cart-button',
    function () {
      var varid = $(this).attr('data-varid');
      $.ajax({
        type: 'POST',
        url: "/cart/add.js",
        dataType: "json",
        data: {
            id: varid,
            quantity: 1
        },
        success: function(){

            $('.cart-drawer input').trigger('blur'); // simluate deselect

            setTimeout(function(){

              $('.cart-drawer input').trigger('input'); // simualte edit

              $('#newmenu-cart .ajax-cart__toggle').click();

            }, 350);
        },
        error: function (errormessage) {

          console.log(errormessage);

        }
      });
    }
  );

  // sortBy col v2
$( "#col_v2_sort select" ).on( "change", function() {
  var storedSort = $( "#col_v2_sort" ).attr('data-sort');
  var newVal = $(this).find(':selected').val();

  if (newVal == storedSort ) {
    // old option we left, ignore
  } else {

    // new option was picked
    var gettheurl = window.location;
    var urlString = window.location.search;
    var urlParams = new URLSearchParams(urlString);

    if ( urlString.includes('sort_by') ) {
      // this page is already sorted
      var dupe = urlParams.get('sort_by');
      var fix = gettheurl.href.replace(dupe, '');
      var newURL = fix + newVal;

    } else {

      var newURL = gettheurl.href + "/?sort_by=" + newVal;

    }

    location.href = newURL;
  }
});


//cart stl agree
$("body").on(  "click", '.firestlcheck [name="checkout"]',
  function () {
    if ($("#stlagree").is(":checked")) {
      $(this).submit();
    } else {
      $("#stlcheck").addClass("stlrequired");
      setTimeout(
      function() {
        alert("You must agree with the STL License to check out.");
      }, 1000);
      return false;
    }
  }
);

// variant fix
$(".p2_variant_quanity .single-option-selector").on('change', function() {
  var newvalue = $(".single-option-selector > option:selected").attr('data-price');
  $(".product__current-price > span").html(newvalue);
});



//menu
$('#newmenu ul li a:not(:only-child)').click(function(e) {
  $(this).siblings('.nav-dropdown').toggle();
  $('#newmenu .dropdown').not($(this).siblings()).hide();
  e.stopPropagation();
});

$('html').click(function() {
  $('#newmenu .nav-dropdown').hide();
});

$('#nav-toggle').click(function() {
  $('#newmenu .nav-list').slideToggle();
  $('#newmenu-right').toggleClass('hidden');
});

$('#nav-toggle').on('click', function() {
  this.classList.toggle('active');
});


// collection
  $( "#MainContent > .index-section--gallery" ).appendTo( "#collection-bundles" );

// product
if ( document.getElementById("product2_top") ) {

  $( "#tab_desc div.changelog" ).appendTo( "#tab_p_change" );

  if (  document.getElementById("printrecommendations") ) {
    $("#printrecommendations").appendTo( "#tab_p_print" );
  } else {
    $(".stl.pagewidth").addClass('norec');
    $("#tab2, #product2_mid_tabs li[title='Print Recommendations'], #tab_print").remove();
  }

  $( "#tab_desc div.size" ).appendTo( "#product2_top_sidebar .printsidebar" );

} else {
  $( "#MainContent div.changelog" ).appendTo( "#shopify-section-product-template .product__form-wrapper" );
}

// faq
  $(".question-wrap:first-child h2").addClass('active');
  $(".question-wrap:first-child p").addClass('active_tab').show();
  $(".question-wrap h2").click(function(){
    if($(this).hasClass('active')){
      //
    }else{
      $(".question-wrap p").removeClass('active_tab').slideUp();
      $(".question-wrap h2").removeClass('active');
      $(this).addClass('active');
      $(this).next().addClass('active_tab').slideDown();
    }
  });

// page.slideshow
$( "#Slideshow-slideshow-sec .slideshow__button-cta" ).hover(
  function() {
    $( "#Slideshow-slideshow-sec .slideshow__slide--active .slideshow__text-content > div" ).attr('style', 'opacity: 0');
    $( "#Slideshow-slideshow-sec .slideshow__slide--active" ).addClass('hiddenoverlay');
  }, function() {
    $( "#Slideshow-slideshow-sec .slideshow__slide--active .slideshow__text-content > div" ).attr('style', 'opacity: 1');
    $( "#Slideshow-slideshow-sec .slideshow__slide--active" ).removeClass('hiddenoverlay');
  }
);
$( "#Slideshow-slideshow-sec2 .slideshow__button-cta" ).hover(
  function() {
    $( "#Slideshow-slideshow-sec2 .slideshow__slide--active .slideshow__text-content > div" ).attr('style', 'opacity: 0');
    $( "#Slideshow-slideshow-sec2 .slideshow__slide--active" ).addClass('hiddenoverlay');
  }, function() {
    $( "#Slideshow-slideshow-sec2 .slideshow__slide--active .slideshow__text-content > div" ).attr('style', 'opacity: 1');
    $( "#Slideshow-slideshow-sec2 .slideshow__slide--active" ).removeClass('hiddenoverlay');
  }
);

// collection filter
  var togglesize_cal1 = 30 / 2;
  var togglesize_cal2 = (30 * 10) - 15;

  var geturl = window.location.href;
  if ( geturl.indexOf('/printed') !== -1 ) {
    //console.log("printed");
    $("#toggleswitchwrap").parent().addClass('currentstate-one');    $("#toggleswitch").addClass('active-one');
  } else if ( geturl.indexOf('/stl') !== -1 ){
    //console.log("stl");
    $("#toggleswitchwrap").parent().addClass('currentstate-three');
    $("#toggleswitch").addClass('active-three');
  } else {
    //console.log("both");
    $("#toggleswitchwrap").parent().addClass('currentstate-two');    $("#toggleswitch").addClass('active-two');
  }

  $("#toogleswitchtext label").keypress(function() {
    var toggleaccesability = "#" + $(this).attr("for");
    $(toggleaccesability).click();
  });
  $('#toggleswitchwrap input[type="radio"]').on("change", function() {
    var togglevalue = $(this).val();
    $("#togglebtn a").attr('href', togglevalue);

    switch ($(this).attr("id")) {
      case "toggleswitch-one":
        $("#toggleswitchwrap, #toggleswitch")
          .removeAttr("class")
          .addClass("active-one");
        $("#toggleswitch").css({ left: togglesize_cal1 + "px" });
        break;
      case "toggleswitch-two":
        $("#toggleswitchwrap, #toggleswitch")
          .removeAttr("class")
          .addClass("active-two");
        $("#toggleswitch").css({ left: "50%" });
        break;
      case "toggleswitch-three":
        $("#toggleswitchwrap, #toggleswitch")
          .removeAttr("class")
          .addClass("active-three");
        $("#toggleswitch").css({ left: togglesize_cal2 + "px" });
        break;
    }
  });

});

// https://codepen.io/djgrant/pen/AwFHL
(function() {

  window.inputNumber = function(el) {

    var min = el.attr('min') || false;
    var max = el.attr('max') || false;

    var els = {};

    els.dec = el.prev();
    els.inc = el.next();

    el.each(function() {
      init($(this));
    });

    function init(el) {

      els.dec.on('click', decrement);
      els.inc.on('click', increment);

      function decrement() {
        var value = el[0].value;
        value--;
        if(!min || value >= min) {
          el[0].value = value;
        }
      }

      function increment() {
        var value = el[0].value;
        value++;
        if(!max || value <= max) {
          el[0].value = value++;
        }
      }
    }
  };
})();

inputNumber($('.input-number'));

/*-----------------------------------------------------------------------------/
/ Carousel
/-----------------------------------------------------------------------------*/

/*!
 * flexCarousel.js v0.2.1
 * https://github.com/tomhrtly/flexCarousel.js
 *
 * Copyright 2018 Tom Hartley
 * Released under the MIT license
 *
 * Icons provided by Font Awesome: https://fontawesome.com
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
}(function($) {

  // Set flexCarousel as a object
  let flexCarousel = window.flexCarousel || {};

  flexCarousel = (function() {
    function flexCarousel(selector, options) {
      const self = this;

      self.defaults = {
        arrows: true,
        arrowsOverlay: true,
        autoplay: false,
        autoplaySpeed: 5000,
        circles: true,
        circlesOverlay: true,
        height: null,
        nextArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>',
        prevArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left" class="svg-inline--fa fa-angle-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg>',
        slidesVisible: 1,
        transition: 'slide',
      };

      // Combine both objects
      self.options = $.extend(self.defaults, options);

      // This will always have active slide index
      self.activeSlide = 0;

      self.selector = $(selector);
      self.init();
    }

    return flexCarousel;
  }());

  let object = flexCarousel.prototype;

  object.autoplay = function() {
    const self = this;

    if(self.options.autoplay) {
      self.timer = setInterval(function() { self.moveSlide('next', 1); }, self.options.autoplaySpeed);
    }
  };

  object.buildArrowEvents = function() {
    const self = this;
    let next = self.selector.find('.fc-next');
    let prev = self.selector.find('.fc-prev');

    if(self.options.arrows) {
      prev.click(function() { self.moveSlide('prev', 1); });
      next.click(function() { self.moveSlide('next', 1); });
    }
  };

  object.buildArrows = function() {
    const self = this;
    let slide = self.selector.find('.fc-slide');

    if(self.options.arrows) {
      if(self.options.slidesVisible < slide.length) {
        self.selector.addClass('fc-arrows');
        self.selector.prepend('<button class="fc-prev"><span class="fc-icon">' + self.options.prevArrow + '</span></button>');
        self.selector.append('<button class="fc-next"><span class="fc-icon">' + self.options.nextArrow + '</span></button>');

        let prev = self.selector.find('.fc-prev');
        let next = self.selector.find('.fc-next');

        next.addClass('fc-is-active');
        prev.addClass('fc-is-active');

        if (self.options.arrowsOverlay) {
          self.selector.addClass('fc-arrow-overlay');
        }
      }
    }
  };

  object.buildCircleEvents = function() {
    let self = this;
    let circle = self.selector.find('.fc-circle');

    if(self.options.circles) {
      circle.click(function() {
        if(!$(this).hasClass('fc-is-active')) {
          let index = $(this).index();
          self.goToSlide(index);
        }
      });
    }
  };

  object.buildCircles = function() {
    let self = this;
    let container = self.selector.find('.fc-container');
    let slide = self.selector.find('.fc-slide:not(.fc-is-clone)');

    if(self.options.circles) {
      if(self.options.slidesVisible < slide.length) {
        self.selector.addClass('fc-circles');
        container.append('<div class="fc-circles" />');

        let circles = self.selector.find('.fc-circles');

        slide.each(function () {
          circles.append('<div class="fc-circle"><span class="fc-icon fc-is-circle"></span></div>');
        });

        let circle = self.selector.find('.fc-circle');

        circle.first().addClass('fc-is-active');

        if (self.options.circlesOverlay) {
          self.selector.addClass('fc-circles-overlay');
        }
      }
    }
  };

  object.buildEvents = function() {
    const self = this;

    self.buildArrowEvents();
    self.buildCircleEvents();
  };

  object.buildSlides = function() {
    const self = this;

    let slide = self.selector.find('> div');
    slide.addClass('fc-slide').wrapAll('<div class="fc-container"><div class="fc-slides ' + self.transitionClasses() + '" /></div>');

    let slideWidth = 100 / self.options.slidesVisible + '%';

    let slides = self.selector.find('.fc-slides');

    if(self.options.slidesVisible < slide.length) {
      slide.css('min-width', 'calc(100% / ' + self.options.slidesVisible + ')');

      slides.css('left', '-' + slideWidth);
/*
      // Clone all the slides, add the correct order property value, slide width and append to the slides container
      // Fixes issue #2
      if(self.options.slidesVisible === slide.length - 1) {
        slide.each(function() {
          $(this).clone().addClass('fc-is-clone').appendTo(slides);
        });
      }
      */
      slides.children().last().css('order', 1);

      let i = 2;
      slides.children().slice(0, slides.children().length - 1).each(function () {
        $(this).css('order', i++);
      });

      slide.each(function() {
        let image = $(this).find('img');
        let imageCaption = image.data('caption');
        let picture = $(this).find('picture');
        let pictureCaption = picture.find('img').data('caption');

        // If the image's parent is picture, wrap the picture tag
        image.parent('picture').wrap('<figure class="fc-image"></figure>');

        // If there is a caption for the image inside the picture, display the caption if it exists
        if(pictureCaption) {
          picture.after('<figcaption>' + imageCaption + '</figcaption>');
        }

        // Wrap the image tag, display the caption if it exists
        function imageWrap() {
          image.wrap('<figure class="fc-image"></figure>');
          if(imageCaption) {
            image.after('<figcaption>' + imageCaption + '</figcaption>');
          }
        }

        // If the image's parent isn't the picture tag, wrap it
        image.parent('picture').length ? '' : imageWrap();
      });

      if(self.options.transition === 'slide') {
        slides.css('transform', 'translateX(' + slideWidth + ')');
      }
    }
  };

  object.changeOrder = function(amount, shift) {
    const self = this;
    let slide = self.selector.find('.fc-slide');
    let slides = self.selector.find('.fc-slides');
    let slideWidth = 100 / self.options.slidesVisible + '%';

    if(amount === 'increase') {
      // Determine whether the carousel is going forward or backward
      if(self.options.transition === 'slide') {
        slides.css('transform', 'translateX(-' + slideWidth + ')');
      }

      slide.each(function() {
        let convertedOrder = parseInt($(this).css('order'));
        let orderIncrease = convertedOrder + shift;

        if(orderIncrease > slide.length) {
          orderIncrease = orderIncrease - slide.length;
        }

        $(this).css('order', orderIncrease);
      });
    } else {
      // Determine whether the carousel is going forward or backward
      if(self.options.transition === 'slide') {
        slides.css('transform', 'translateX(' + slideWidth + ')');
      }

      slide.each(function() {
        let convertedOrder = parseInt($(this).css('order'));
        let orderDecrease = convertedOrder - shift;

        if(orderDecrease <= 0) {
          orderDecrease = slide.length + orderDecrease;
        }

        $(this).css('order', orderDecrease);
      });
    }
  };

  object.goToSlide = function(position) {
    const self = this;
    let activeSlide = self.activeSlide;
    let direction = position > activeSlide ? "next": "prev";
    let shift = Math.abs(activeSlide - position);

    self.moveSlide(direction, shift);
  };

  object.height = function() {
    const self = this;

    if(self.options.height) {
      self.selector.css('height', self.options.height);
    }
  };

  object.init = function() {
    const self = this;

    if(!self.selector.hasClass('fc')) {
      self.selector.addClass('fc');

      self.buildSlides();
      self.buildArrows();
      self.buildCircles();
      self.buildEvents();
      self.height();
      self.autoplay();
    }
  };

  object.moveSlide = function(direction, shift) {

    $('.car-slide').removeClass('active-slide');

    const self = this;
    let activeSlide = self.activeSlide;
    let circle = self.selector.find('.fc-circle');
    let slides = self.selector.find('.car-slide');

    if(direction) {
      setTimeout(function () { self.transition(); }, 1);
      self.transition();
    }

    if(direction === 'next') {
      self.changeOrder('decrease', shift);
    } else {
      self.changeOrder('increase', shift);
    }


    // updating active slide number every time slide changes
    self.updateActiveSlideNumber(direction, shift);
    circle.eq(activeSlide).removeClass('fc-is-active');
    circle.eq(self.activeSlide).addClass('fc-is-active');

    slides.eq(self.activeSlide).addClass('active-slide');

  };

  object.transition = function() {
    const self = this;
    let slides = self.selector.find('.fc-slides');

    if(self.options.transition === 'slide') {
      slides.toggleClass('fc-slide-animation');
    }
  };

  object.transitionClasses = function() {
    const self = this;

    if(self.options.transition === 'slide') {
      return 'fc-slide-animation';
    }
  };

  object.updateActiveSlideNumber = function(direction, shift) {
    const self = this;
    let slide = self.selector.find('.fc-slide:not(.fc-is-clone)');

    if(direction === 'next') {
      self.activeSlide += shift;
      if(self.activeSlide >= slide.length) {
        self.activeSlide = 0;
      }
    } else {
      self.activeSlide -= shift;
      if(self.activeSlide < -slide.length) {
        self.activeSlide = slide.length - 1;
      }
    }
  };

  $.fn.flexCarousel = function() {
    const self = this;
    let options = arguments[0];

    for (let i = 0; i < self.length; i++) {
      if (typeof options == 'object' || typeof options == 'undefined') {
        self[i].flexCarousel = new flexCarousel(self[i], options);
      }
    }

    return self;
  };
}));

$(document).ready(function() {
  $('.home-carousel > div').flexCarousel({
    //autoplay: true,
    //autoplaySpeed: 8500,
    autoplay: false,
    transitionSpeed: 90000,
    arrowsOverlay: false
  });
});

/*-----------------------------------------------------------------------------/
/ Collection 2.0 https://codepen.io/Wroth/pen/ExYmdga
/-----------------------------------------------------------------------------*/

!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Slideout=t()}}(function(){var t,e,n;return function i(t,e,n){function o(r,a){if(!e[r]){if(!t[r]){var u=typeof require=="function"&&require;if(!a&&u)return u(r,!0);if(s)return s(r,!0);var l=new Error("Cannot find module '"+r+"'");throw l.code="MODULE_NOT_FOUND",l}var h=e[r]={exports:{}};t[r][0].call(h.exports,function(e){var n=t[r][1][e];return o(n?n:e)},h,h.exports,i,t,e,n)}return e[r].exports}var s=typeof require=="function"&&require;for(var r=0;r<n.length;r++)o(n[r]);return o}({1:[function(t,e,n){"use strict";var i=t("decouple");var o=t("emitter");var s;var r=false;var a=window.document;var u=a.documentElement;var l=window.navigator.msPointerEnabled;var h={start:l?"MSPointerDown":"touchstart",move:l?"MSPointerMove":"touchmove",end:l?"MSPointerUp":"touchend"};var f=function v(){var t=/^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;var e=a.getElementsByTagName("script")[0].style;for(var n in e){if(t.test(n)){return"-"+n.match(t)[0].toLowerCase()+"-"}}if("WebkitOpacity"in e){return"-webkit-"}if("KhtmlOpacity"in e){return"-khtml-"}return""}();function c(t,e){for(var n in e){if(e[n]){t[n]=e[n]}}return t}function p(t,e){t.prototype=c(t.prototype||{},e.prototype)}function d(t){while(t.parentNode){if(t.getAttribute("data-slideout-ignore")!==null){return t}t=t.parentNode}return null}function _(t){t=t||{};this._startOffsetX=0;this._currentOffsetX=0;this._opening=false;this._moved=false;this._opened=false;this._preventOpen=false;this.panel=t.panel;this.menu=t.menu;this._touch=t.touch===undefined?true:t.touch&&true;this._side=t.side||"left";this._easing=t.fx||t.easing||"ease";this._duration=parseInt(t.duration,10)||300;this._tolerance=parseInt(t.tolerance,10)||70;this._padding=this._translateTo=parseInt(t.padding,10)||256;this._orientation=this._side==="right"?-1:1;this._translateTo*=this._orientation;if(!this.panel.classList.contains("slideout-panel")){this.panel.classList.add("slideout-panel")}if(!this.panel.classList.contains("slideout-panel-"+this._side)){this.panel.classList.add("slideout-panel-"+this._side)}if(!this.menu.classList.contains("slideout-menu")){this.menu.classList.add("slideout-menu")}if(!this.menu.classList.contains("slideout-menu-"+this._side)){this.menu.classList.add("slideout-menu-"+this._side)}if(this._touch){this._initTouchEvents()}}p(_,o);_.prototype.open=function(){var t=this;this.emit("beforeopen");if(!u.classList.contains("slideout-open")){u.classList.add("slideout-open")}this._setTransition();this._translateXTo(this._translateTo);this._opened=true;setTimeout(function(){t.panel.style.transition=t.panel.style["-webkit-transition"]="";t.emit("open")},this._duration+50);return this};_.prototype.close=function(){var t=this;if(!this.isOpen()&&!this._opening){return this}this.emit("beforeclose");this._setTransition();this._translateXTo(0);this._opened=false;setTimeout(function(){u.classList.remove("slideout-open");t.panel.style.transition=t.panel.style["-webkit-transition"]=t.panel.style[f+"transform"]=t.panel.style.transform="";t.emit("close")},this._duration+50);return this};_.prototype.toggle=function(){return this.isOpen()?this.close():this.open()};_.prototype.isOpen=function(){return this._opened};_.prototype._translateXTo=function(t){this._currentOffsetX=t;this.panel.style[f+"transform"]=this.panel.style.transform="translateX("+t+"px)";return this};_.prototype._setTransition=function(){this.panel.style[f+"transition"]=this.panel.style.transition=f+"transform "+this._duration+"ms "+this._easing;return this};_.prototype._initTouchEvents=function(){var t=this;this._onScrollFn=i(a,"scroll",function(){if(!t._moved){clearTimeout(s);r=true;s=setTimeout(function(){r=false},250)}});this._preventMove=function(e){if(t._moved){e.preventDefault()}};a.addEventListener(h.move,this._preventMove);this._resetTouchFn=function(e){if(typeof e.touches==="undefined"){return}t._moved=false;t._opening=false;t._startOffsetX=e.touches[0].pageX;t._preventOpen=!t._touch||!t.isOpen()&&t.menu.clientWidth!==0};this.panel.addEventListener(h.start,this._resetTouchFn);this._onTouchCancelFn=function(){t._moved=false;t._opening=false};this.panel.addEventListener("touchcancel",this._onTouchCancelFn);this._onTouchEndFn=function(){if(t._moved){t.emit("translateend");t._opening&&Math.abs(t._currentOffsetX)>t._tolerance?t.open():t.close()}t._moved=false};this.panel.addEventListener(h.end,this._onTouchEndFn);this._onTouchMoveFn=function(e){if(r||t._preventOpen||typeof e.touches==="undefined"||d(e.target)){return}var n=e.touches[0].clientX-t._startOffsetX;var i=t._currentOffsetX=n;if(Math.abs(i)>t._padding){return}if(Math.abs(n)>20){t._opening=true;var o=n*t._orientation;if(t._opened&&o>0||!t._opened&&o<0){return}if(!t._moved){t.emit("translatestart")}if(o<=0){i=n+t._padding*t._orientation;t._opening=false}if(!(t._moved&&u.classList.contains("slideout-open"))){u.classList.add("slideout-open")}t.panel.style[f+"transform"]=t.panel.style.transform="translateX("+i+"px)";t.emit("translate",i);t._moved=true}};this.panel.addEventListener(h.move,this._onTouchMoveFn);return this};_.prototype.enableTouch=function(){this._touch=true;return this};_.prototype.disableTouch=function(){this._touch=false;return this};_.prototype.destroy=function(){this.close();a.removeEventListener(h.move,this._preventMove);this.panel.removeEventListener(h.start,this._resetTouchFn);this.panel.removeEventListener("touchcancel",this._onTouchCancelFn);this.panel.removeEventListener(h.end,this._onTouchEndFn);this.panel.removeEventListener(h.move,this._onTouchMoveFn);a.removeEventListener("scroll",this._onScrollFn);this.open=this.close=function(){};return this};e.exports=_},{decouple:2,emitter:3}],2:[function(t,e,n){"use strict";var i=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||function(t){window.setTimeout(t,1e3/60)}}();function o(t,e,n){var o,s=false;function r(t){o=t;a()}function a(){if(!s){i(u);s=true}}function u(){n.call(t,o);s=false}t.addEventListener(e,r,false);return r}e.exports=o},{}],3:[function(t,e,n){"use strict";var i=function(t,e){if(!(t instanceof e)){throw new TypeError("Cannot call a class as a function")}};n.__esModule=true;var o=function(){function t(){i(this,t)}t.prototype.on=function e(t,n){this._eventCollection=this._eventCollection||{};this._eventCollection[t]=this._eventCollection[t]||[];this._eventCollection[t].push(n);return this};t.prototype.once=function n(t,e){var n=this;function i(){n.off(t,i);e.apply(this,arguments)}i.listener=e;this.on(t,i);return this};t.prototype.off=function o(t,e){var n=undefined;if(!this._eventCollection||!(n=this._eventCollection[t])){return this}n.forEach(function(t,i){if(t===e||t.listener===e){n.splice(i,1)}});if(n.length===0){delete this._eventCollection[t]}return this};t.prototype.emit=function s(t){var e=this;for(var n=arguments.length,i=Array(n>1?n-1:0),o=1;o<n;o++){i[o-1]=arguments[o]}var s=undefined;if(!this._eventCollection||!(s=this._eventCollection[t])){return this}s=s.slice(0);s.forEach(function(t){return t.apply(e,i)});return this};return t}();n["default"]=o;e.exports=n["default"]},{}]},{},[1])(1)});

if (document.getElementById("it_col_v2_panel")) {
  var slideout = new Slideout({
    'panel': document.getElementById('it_col_v2_panel'),
  	'menu': document.getElementById('menu'),
  	'padding': 300,
  	'duration': 400,
  	'tolerance': 70,
    'easing': 'ease-in-out'
  });

  $('#it_col_v2 .toggle-button').on('click', function() {
    slideout.toggle();
  });

  slideout.on('beforeopen', function() {
  	$('body').addClass('sideopening');
  	$('body').removeClass('sideclosed');
  });
  slideout.on('open', function() {
  	$('body').addClass('sideopen');
  	$('body').removeClass('sideclosed');
  	$('body').removeClass('sideopening');
  	$('.toggle-button span').html('hide');
  });
  slideout.on('beforeclose', function() {
  	$('body').addClass('sideclosing');
  });
  slideout.on('close', function() {
  	$('body').removeClass('sideclosing');
  	$('body').removeClass('sideopen');
  	$('body').addClass('sideclosed');
  	$('.toggle-button span').html('show');
  });

}

$( document ).ready(function() {
  if (document.getElementById("it_col_v2_panel")) {

    $("body").css('overflow-x', 'hidden');

    var tagcheck = document.location.pathname;
  	var tagURL = [];
  	tagURL = tagcheck.split('/');
  	var tagLast = tagURL[tagURL.length - 1];

    // make sure it's not filtered and if it is fix tag
    if ( tagLast == "" ) {
      console.log("search");
    	tagLast = tagURL[tagURL.length - 2];
      var tagText = $("#menu a[data-handle='"+tagLast+"']").text();
      $("#col_v2_url").text(tagText);
    } else {
      console.log("no search");
      var tagText = $("#menu a[data-handle='"+tagLast+"']").text();
      $("#col_v2_url").text(tagText);
    }

    var colhandle = $('#slide-bread').attr('data-colhandle');
    if ( colhandle == tagLast ) {
      $("#slide-bread").attr('aria-hidden', 'true');
    } else {
      $("#slide-bread").css('display', 'block');
    }

    // update menu sorting
    var sortingUrl = window.location.search;
    var sortingStringParams = new URLSearchParams(sortingUrl);

    if ( sortingStringParams.has("sort_by") ) {

      var menuSort = sortingStringParams.get("sort_by");

      $("#menu").find("a[data-handle]").each(function() {

        var oldLink = $( this ).attr( "href" );
        var newLink = oldLink + "/?sort_by=" + menuSort;

        $( this ).attr( "href", newLink );

      });

    }

    var tagfiltercounter = 0;
    $("#menu ul li a").each( function(){
      let eachtaghandle = $(this).attr('data-handle');
      if ( eachtaghandle == tagLast ) {
        $(this).parent().addClass('active');
        tagfiltercounter++;
      }
    });
    if ( tagfiltercounter === 0) {
      $('#menu > ul li').first().addClass('active');
    }

    if ($(window).width() < 750) {
      slideout.close();
      $('body').addClass('sideclosed');
    }
    else {
      slideout.open();
    }

/*
    $.fn.lastWord = function() {
      var text = this.text().trim().split(" ");
      var last = text.pop();
      this.html(text.join(" ") + (text.length > 0 ? " <span class='lastWord'>" + last + "</span>" : last));
    };
    $(".bundle-grid span.money").lastWord();
*/

  }
});

/*-----------------------------------------------------------------------------/
/ Product 2.0
/-----------------------------------------------------------------------------*/

$( ".p2_variant > select" ).change(function() {
  var variantselected = $( ".p2_variant > select option:selected" ).attr('data-title');

  var variantselectedval = $(".single-option-selector option[data-title='"+variantselected+"']").attr('value');

  $(".single-option-selector").val(variantselectedval);

  //console.log(variantselectedval);

});
